import Loading from './../misc/Loading';
import React from 'react';
import WarrantyPeriodComponent from './WarrantyPeriod';
import warrantyPeriodModel from '../../../../model/warrantyPeriod';
import makeModel from '../../../../model/makes';
import update from 'immutability-helper';
import ValidationError from '../../../../model/error/ValidationError';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import {mapMakeToMakeId} from '/src/components/misc/utils';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Perioden validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av periode og handlingen kunne dermed ikke fullføres.';
};

class WarrantyPeriodContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      warrantyPeriod: null,
      makeName: null,
      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnarchive = this.handleUnarchive.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.make) {
      this.fetchWarrantyPeriod(this.props.match.params.make, this.props.match.params.periodId);
    }
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    if (next.match.params.make && next.match.params.periodId) {
      this.setState({
        warrantyPeriod: null
      });
      this.fetchWarrantyPeriod(next.match.params.make, next.match.params.periodId);
    }
  }

  fetchWarrantyPeriod(makeName, periodIdParam) {
    let periodId = null;
    if (periodIdParam && periodIdParam !== 'new') {
      periodId = periodIdParam;
    }

    const makeId = mapMakeToMakeId[makeName];

    if (periodId) {
      warrantyPeriodModel.getById(periodId, 2).then((warrantyPeriod) => {
        document.title = `Admin - Garantiperiode - ${warrantyPeriod.title}`;
        this.setState({
          warrantyPeriod: warrantyPeriod,
          makeName: makeName
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else if (makeId && periodId === null) {
      Promise.all([
        warrantyPeriodModel.createEmpty(),
        makeModel.getById(makeId, 2)
      ]).then(([warrantyPeriod, make]) => {
        warrantyPeriod.make = make;
        this.setState({
          warrantyPeriod: warrantyPeriod,
          makeName: makeName
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.warrantyPeriod.id;

    if (isCreate) {
      warrantyPeriodModel.new(this.state.warrantyPeriod, 2).then((warrantyPeriod) => {
        this.setState({
          working: false,
          warrantyPeriod: warrantyPeriod
        });
        this.props.history.push(`/warrantyperiods/${this.state.makeName}/${warrantyPeriod.id}`);
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      warrantyPeriodModel.save(this.state.warrantyPeriod, 2).then((warrantyPeriod) => {
        this.setState({
          working: false,
          warrantyPeriod: warrantyPeriod
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handlePublish() {
    this.setState({
      error: null,
      working: true
    });
    warrantyPeriodModel.publish(this.state.warrantyPeriod.id, 2).then((warrantyPeriod) => {
      this.setState({
        working: false,
        warrantyPeriod: warrantyPeriod
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      error: null,
      working: true
    });
    warrantyPeriodModel.unpublish(this.state.warrantyPeriod.id, 2).then((warrantyPeriod) => {
      this.setState({
        working: false,
        warrantyPeriod: warrantyPeriod
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      error: null,
      working: true
    });
    warrantyPeriodModel.archive(this.state.warrantyPeriod.id, 2).then((warrantyPeriod) => {
      this.setState({
        working: false,
        warrantyPeriod: warrantyPeriod
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnarchive() {
    this.setState({
      error: null,
      working: true
    });
    warrantyPeriodModel.unarchive(this.state.warrantyPeriod.id, 2).then((warrantyPeriod) => {
      this.setState({
        working: false,
        warrantyPeriod: warrantyPeriod
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.warrantyPeriod) {
      return (
        <section className="mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to={`/warrantyperiods/${this.state.makeName}`}>Garantiperioder</Link></li>
            <li className="active">...</li>
          </ol>
          <Loading title="Garantiperiode" text="Laster garantiperiode" />
        </section>
      );
    }

    return (
      <WarrantyPeriodComponent
        warrantyPeriod={this.state.warrantyPeriod}
        makeName={this.state.makeName}
        error={this.state.error}
        modified={this.state.modified}
        working={this.state.working}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.state.warrantyPeriod.id ? this.handlePublish : null}
        onUnpublish={this.state.warrantyPeriod.id ? this.handleUnpublish : null}
        onArchive={this.state.warrantyPeriod.id ? this.handleArchive : null}
        onUnarchive={this.state.warrantyPeriod.id ? this.handleUnarchive : null}
      />
    );
  }
}

export default withRouter(WarrantyPeriodContainer);
